import { z } from 'zod';
/** A Postgres `uuid` primary/foreign key. */
export const UuidSchema = z.uuid();
/**
 * Any value the `uuid` **column type** accepts — the 8-4-4-4-12 hex form, with
 * no version/variant requirement.
 *
 * {@link UuidSchema} is `z.uuid()`, which enforces RFC 9562's version and
 * variant nibbles. That is the right rule for an id this API *generates* (v4
 * or v7, always). It is the wrong rule for an id it merely *reports*, because
 * Postgres is happy with values RFC 9562 has no version for — and the schema
 * uses one: `platform_settings` is a singleton keyed
 * `00000000-0000-0000-0000-000000000001`.
 *
 * `settings.update` is a catalogued audit action, so that id reaches
 * `audit_events.entity_id`, and a stricter contract than the database turned
 * every audit page containing one into a `500` from the response-DTO layer.
 * Use this only where the value comes back **from a `uuid` column**, never on
 * a request.
 */
export const DbUuidSchema = z.guid();
/**
 * A `timestamptz` instant, always UTC, always `Z`-suffixed (D-13). Client
 * payloads that legitimately need an offset (there are none in V1) would need
 * a dedicated schema — every instant in this system round-trips through UTC.
 */
export const IsoDateTimeSchema = z.iso.datetime();
/** A `date` business date, `YYYY-MM-DD`, no time component. */
export const IsoDateSchema = z.iso.date();
/** Local wall-clock time, `HH:mm`, 24h. Used for `shift_series.start_time`/`end_time`. */
export const LocalTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Expected HH:mm (24h)');
/** IANA timezone identifier, e.g. `America/Montreal`. Format-checked, not looked up. */
export const IanaTimezoneSchema = z
    .string()
    .min(1)
    .regex(/^[A-Za-z_]+\/[A-Za-z_+\-0-9]+(\/[A-Za-z_+\-0-9]+)?$|^UTC$/, 'Expected an IANA timezone identifier');
//# sourceMappingURL=ids.js.map